/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assertAndContinue} from 'Asserts';
import ReviewConstants, {ReviewSummary} from 'notebook/reviews/ReviewConstants';
import {REVIEW_CRITERION_STATUS, ReviewCriterion} from 'notebook/reviews/ReviewCriteriaConstants';

interface Props {
  review?: ReviewSummary;
  reviewCriterion: ReviewCriterion;
  updateReviewCriterion?: (...args: Array<any>) => any;
  enabled: boolean;
}

type State = any;

export class CheckableReviewCriterionRow extends React.Component<Props, State> {
  override state: State = {savingStatus: null};

  _toggleStatus = async (status: any): Promise<void> => {
    try {
      const newStatus =
        this.props.reviewCriterion.status === status ? REVIEW_CRITERION_STATUS.UNREVIEWED : status;
      this.setState({savingStatus: newStatus});
      await this.props.updateReviewCriterion!(this.props.reviewCriterion.id, {status: newStatus});
    } finally {
      this.setState({savingStatus: null});
    }
  };

  _handleSetStatusFailed = (): void => {
    this._toggleStatus(REVIEW_CRITERION_STATUS.FAILED);
  };

  _handleSetStatusPassed = (): void => {
    this._toggleStatus(REVIEW_CRITERION_STATUS.PASSED);
  };

  override render(): JSX.Element {
    const {review, reviewCriterion} = this.props;
    const inputName = `criterion-row-${reviewCriterion.id}`;
    const enabled =
      review &&
      review.status === ReviewConstants.NEEDS_REVIEW &&
      this.props.enabled &&
      this.state.savingStatus == null;

    assertAndContinue(
      this.props.updateReviewCriterion != null || !enabled,
      'updateReviewCriterion must be specified if pass/fail is settable'
    );

    const renderedStatus = this.state.savingStatus || reviewCriterion.status;

    return (
      <div className="simpleDivTable-row">
        <div className="checkableCriterionRow-container">
          <div className="checkableCriterionRow-passFail">
            <input
              type="radio"
              name={inputName}
              disabled={!enabled}
              checked={renderedStatus === REVIEW_CRITERION_STATUS.PASSED}
              onChange={this._handleSetStatusPassed}
            />
          </div>
          <div className="checkableCriterionRow-passFail u-small-spacing-right">
            <input
              type="radio"
              name={inputName}
              disabled={!enabled}
              checked={renderedStatus === REVIEW_CRITERION_STATUS.FAILED}
              onChange={this._handleSetStatusFailed}
            />
          </div>
          <div className="checkableCriterionRow-text">{this.props.reviewCriterion.text}</div>
        </div>
      </div>
    );
  }
}

export default CheckableReviewCriterionRow;
